import { computed, inject, Injectable } from "@angular/core"
import { RouteService } from "../services/route.service"
import { ClevelandOhRegion } from "./cleveland-oh.region"
import { BaltimoreMdRegion } from "./baltimore-md.region"
import { RegionsEnum } from "redlineLibs"
import { DetroitMiRegion } from "./detroit-mi.region"
import { BostonMaRegion } from "./boston-ma.region"
import { NarRegion } from "./nar.region"
import { NychdcRegion } from "./nychdc.region"
import { EmergentworksRegion } from "./emergentworks.region"

@Injectable({
  providedIn: "root",
})
export class RegionsService {
  private routeService = inject(RouteService)
  private clevelandOhRegion = inject(ClevelandOhRegion)
  private baltimoreMdRegion = inject(BaltimoreMdRegion)
  private detroitMiRegion = inject(DetroitMiRegion)
  private bostonMaRegion = inject(BostonMaRegion)
  private narRegion = inject(NarRegion)
  private nychdcRegion = inject(NychdcRegion)
  private ewRegion = inject(EmergentworksRegion)

  region = this.routeService.region

  localVideo = computed(() => {
    switch (this.routeService.region()) {
      case RegionsEnum.NYCHDC:
        return this.nychdcRegion.localVideo()
      case RegionsEnum.EMERGENTWORKS:
        return this.ewRegion.localVideo()
      case RegionsEnum.NAR:
        return this.narRegion.localVideo()
      case RegionsEnum.BALTIMORE_MD:
        return this.baltimoreMdRegion.localVideo()
      case RegionsEnum.CLEVELAND_OH:
        return this.clevelandOhRegion.localVideo()
      case RegionsEnum.DETROIT_MI:
        return this.detroitMiRegion.localVideo()
      case RegionsEnum.BOSTON_MA:
        return this.bostonMaRegion.localVideo()
      default:
        return undefined
    }
  })

  brandHeader = computed(() => {
    switch (this.routeService.region()) {
      case RegionsEnum.NYCHDC:
        return this.nychdcRegion.brandHeader()
      case RegionsEnum.EMERGENTWORKS:
        return this.ewRegion.brandHeader()
      case RegionsEnum.NAR:
        return this.narRegion.brandHeader()
      case RegionsEnum.BALTIMORE_MD:
        return this.baltimoreMdRegion.brandHeader()
      case RegionsEnum.CLEVELAND_OH:
        return this.clevelandOhRegion.brandHeader()
      case RegionsEnum.DETROIT_MI:
        return this.detroitMiRegion.brandHeader()
      case RegionsEnum.BOSTON_MA:
        return this.bostonMaRegion.brandHeader()
      default:
        return undefined
    }
  })

  regionProperties = computed(() => {
    switch (this.routeService.region()) {
      case RegionsEnum.NYCHDC:
        return this.nychdcRegion.regionProperties()
      case RegionsEnum.EMERGENTWORKS:
        return this.ewRegion.regionProperties()
      case RegionsEnum.NAR:
        return this.narRegion.regionProperties()
      case RegionsEnum.BALTIMORE_MD:
        return this.baltimoreMdRegion.regionProperties()
      default:
        return undefined
    }
  })

}
